import { render } from "./ErrorAlert.vue?vue&type=template&id=546b194d"
import script from "./ErrorAlert.vue?vue&type=script&lang=js"
export * from "./ErrorAlert.vue?vue&type=script&lang=js"
script.render = render

export default script